import React, { useEffect,useState } from 'react';
import Modal from 'components/shared/Modal';
import { EN_SHORT_FEES, ES_SHORT_FEES, GET_STEP_DOCUMENT_PROGRESS_BAR } from 'constants/App';
import { useDispatch,useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';

import { getArticles, putArticles } from 'middleware/documents';
import { getArticleById, locale } from 'utils/helpers';
import Button from 'components/shared/Button.styled';
import { renderCheckboxField } from 'utils/formUtils';
import { notification } from 'services/notification';
import history from 'utils/history';
import { ROUTES } from 'constants/AppRoutes';

const ShortFeesAgreement = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const articles = useSelector((state) => state.documents.list?.result || []);
  const isChecked = useSelector((state) => state.form.shortFees?.values?.agreement);
  const [isBottom, setIsBottom] = useState(false);

  useEffect(() => {
    dispatch({
        type: GET_STEP_DOCUMENT_PROGRESS_BAR,
        data: { title: t('FEES_TEXT'), documentStep: 2 }
    })
    dispatch(getArticles())
  },[])

  useEffect(() => {
    if(window?.innerWidth < 1024){
      setIsBottom(true)
    }
  }, [window?.innerWidth])

  const shortFeesAgreement = () => {
    if(!isBottom){
      notification('error', t('SCROLL_TO_BOTTOM'));
    } else {
    dispatch(putArticles('short'))
    history.push(ROUTES.LONG_FEES_DOCUMENT)
    }
  }

  const handleScroll = (event) => {
    const target = event?.target;
    if(target.scrollHeight - target.scrollTop <= target.clientHeight + 10){
      setIsBottom(true)
    }
  }

  const handleLoad = () => {
    const height = document.querySelector('.overflow-page').offsetHeight;
    const fullHeight = document.querySelector('.overflow-page').scrollHeight;
    if(height === fullHeight){
      setIsBottom(true)
    }
  }

  return (
    <>
    <Modal
      show={true}
    >
       <div className="fees-block-short">
       <div className="overflow-page" onLoad={() => handleLoad()} onScroll={(e) => handleScroll(e)}>
      {getArticleById(articles, locale() === 'en' ? EN_SHORT_FEES : ES_SHORT_FEES)}
      </div>
      </div>
      <div className="d-flex">
      <Field
        name="agreement"
        type="checkbox"
        component={renderCheckboxField}
      />
      <p>{t('ACCEPT_TNC')}</p>
      </div>
      <div className="text-center">
      <Button
        outlined
        type='submit'
        disabled={!isChecked}
        onClick={() => shortFeesAgreement()}
      >{t('AGREE_TEXT')}
      </Button>
      </div>
    </Modal>
    </>
  )
}

export default reduxForm({
  form: 'shortFees', // a unique identifier for this form
  destroyOnUnmount: false,
})(ShortFeesAgreement);